export default "__VITE_ASSET__BSlg$OXR__"